export enum AuthError {
  INVALID_CREDENTIALS = "Invalid credentials.",
  USER_NOT_FOUND = "User not found.",
  EMAIL_ALREADY_EXISTS = "email already exists.",
  USER_ALREAY_EXISTS = "Username is already taken.",
  PASSWORD_TOO_WEAK = "Password too weak.",
  UNKNOWN_ERROR = "Something went wrong. Please try again.",
  NETWORK_ERROR = "Network error.",
}

export enum FormError {
  FILL_ALL_FIELDS = "Please fill all the required fields.",
}

export enum ValidationError {
  USERNAME_MAX = "Username must be less than 16 characters.",
  USERNAME_PATTERN = "Username must be 4+ chars and start with letter(a-z) or (A-Z).",
  PASSWORD_MAX = "Password must be less than 25 characters.",
  PASSWORD_PATTERN = "Password must include: A-Z, a-z, 0-9, symbol.",
  INVALID_EMAIL = "Invalid email address.",
  PASSWORD_MISMATCH = "Passwords do not match.",
}

export enum OrganizationValidate {
  CATEGORY_PATTERN = "Category must be 4+ chars and  start with a letter (a-z) or (A-Z).",
  ORGANIZATION_CREATED = "Organization created successfully.",
}

export enum ToastMessages {
  LOGOUT_SUCCESS = "Successfully logged out.",
  ERROR = "Something went wrong.",
  CANCELLED = "Successfully cancelled the process.",
  USER_DETAIL_FETCH_FAILED = "Failed to fetch user details.",
  USER_ROLE_FETCH_FAILED = "Failed to fetch user role.",
  EXPENSE_FETCH_FAILED = "Failed to fetch expenses.",
  BRANCH_FETCH_FAILED = "Failed to fetch branch.",
  BRANCH_DELETE_FAILED = "Failed to delete branch.",
  BRANCH_DELETE = "Branch deleted Successfully.",
  BRANCH_ID_REQUIRED = "Branch Id is required.",
}
export enum ToastSuccessMessages {
  LOGOUT_SUCCESS = "Successfully logged out.",
  LOGIN_SUCCESS = "Successfully logged in.",
  FORGOT_PASSWORD_EMAIL_SENT = "An email has been sent successfully. Please check your email to reset your password.",
  CATEGORY_ID_REQUIRED = "Category Id is required.",
  PASSWORD_CHANGED = "Password changed successfully.",
}

export enum OrganizationError {
  INVALID_CREDENTIALS = "Invalid credentials or token.",
}

export enum Branch {
  BRANCH_FETCH_FAILED = "Failed to fetch branch.",
  BRANCH_DELETE_FAILED = "Failed to delete branch.",
  BRANCH_DELETE = "Branch deleted Successfully.",
  BRANCH_ID_REQUIRED = "Branch Id is required.",
  BRANCH_EXISTS = "Branch with that name already exists.",
}
export enum CategoryMessage {
  CATEGORY_DELETE = "Category deleted successfully.",
  CATEGORY_UPDATED = "Category updated successfully.",
  CATEGORY_CREATED = "Category created successfully.",
}
export enum BranchError {
  BRANCH_FETCH_FAILED = "Failed to fetch branch.",
  BRANCH_CREATED = "Branch created successfully.",
  BRANCH_UPDATED = "Branch updated.",
  BRANCH_DELETE = "Branch deleted Successfully.",
  BRANCH_ID_REQUIRED = "Branch Id is required.",
  BRANCH_EXISTS = "Branch with that name already exists.",
}
export enum MemberErrors {
  MEMBER_INVITED = "Invitation sent successfully.",
  ORGANIZATION_ID_REQUIRED = "Organization id is required.",
  MEMBER_ID_REQUIRED = "Member id is required.",
  ROLE_REQUIRED = "role is required.",
  MEMBER_FETCH_FAILED = "Failed to fetch members.",
  MEMBER_DELETE_FAILED = "Failed to delete member.",
  MEMBER_DELETE = "Member deleted successfully.",
  MEMBER_UPDATED = "Member updated successfully.",
}

export enum Expense {
  EXPENSE_DELETE_FAILED = "Failed to delete expense.",
  EXPENSE_UPDATE_FAILED = "Failed to update expense.",
  EXPENSE_FETCH_FAILED = "Failed to fetch expense.",
  EXPENSE_ID_REQUIRaED = "Expense Id is required.",
  EXPENSE_DELETE = "Expense deleted Successfully.",
  EXPENSE_EXISTS = "Expense with that name already exists.",
  EXPENSE_CREATED = "Expense created successfully.",
  EXPENSE_UPDATED = "Expense updated successully.",
}
export enum SignInSuccess {
  SIGN_IN_SUCCESS = "Signed in successfully.",
}
export enum ItemError {
  ITEM_FETCH_FAILED = "Failed to fetch item.",
  ITEM_DELETE_FAILED = "Failed to delete item.",
  ITEM_DELETE = "Item deleted Successfully.",
  ITEM_ID_REQUIRED = "Item Id is required.",
  ITEM_EXISTS = "Item with that name already exists.",
}
export enum ItemSuccess {
  ITEM_CREATED = "Item created successfully.",
  ITEM_UPDATED = "Item Updated successfully.",
}
